import { WALL_EVENTS, HOT_TAGS } from '@/mocks/gossip';

const TYPE_STYLE: Record<string, string> = {
  已实锤: 'bg-primary-100 text-primary-800 border-primary-200',
  在回应: 'bg-accent-100 text-accent-900 border-accent-200',
  待续锤: 'bg-secondary-100 text-secondary-900 border-secondary-200',
  已回应: 'bg-background-200 text-foreground-700 border-background-300',
};

export default function TagWall() {
  return (
    <section id="tagwall" className="border-b border-background-200/70 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <div className="mb-6 flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <h2 className="flex items-center gap-2 text-2xl font-bold tracking-wide text-foreground-950 md:text-[1.7rem]">
              <i className="ri-vip-diamond-line text-primary-500" aria-hidden="true" />
              人物争议 · 话题墙
            </h2>
            <p className="mt-1.5 text-sm text-foreground-600">
              按“状态”把正在发酵的<b>婚内出轨事件</b>钉在墙上，一眼看清谁实锤、谁在回应、谁还有续。
            </p>
          </div>
          <span className="shrink-0 text-xs text-foreground-500">共 {WALL_EVENTS.length} 组在榜 · 实时更新</span>
        </div>

        {/* 人物卡片带 */}
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {WALL_EVENTS.map((ev) => (
            <article
              key={ev.id}
              className="flex flex-col rounded-xl border border-background-200/70 bg-background-50 p-5 transition-colors hover:border-primary-200"
            >
              <div className="flex items-center justify-between">
                <span
                  className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full border px-2.5 py-0.5 text-[11px] font-medium ${TYPE_STYLE[ev.type]}`}
                >
                  <i className="ri-record-circle-line" aria-hidden="true" />
                  {ev.type}
                </span>
                <span className="flex items-center gap-0.5 text-xs font-bold text-primary-600">
                  <i className="ri-fire-fill text-primary-500" aria-hidden="true" />
                  {ev.hot}
                </span>
              </div>
              <h3 className="mt-3 font-heading text-2xl tracking-[0.2em] text-foreground-950">{ev.person}</h3>
              <p className="mt-0.5 text-xs text-secondary-700">{ev.role}</p>
              <p className="mt-3 flex-1 text-xs leading-6 text-foreground-700">{ev.desc}</p>
              <button
                type="button"
                className="mt-4 cursor-pointer whitespace-nowrap self-start rounded-md bg-secondary-500 px-3 py-1.5 text-xs font-medium text-background-50 transition-colors hover:bg-secondary-600"
              >
                跟进完整时间线 <i className="ri-arrow-right-line ml-0.5" aria-hidden="true" />
              </button>
            </article>
          ))}
        </div>

        {/* 标签云 */}
        <div className="mt-6 rounded-xl border border-background-200/70 bg-background-50 p-5">
          <div className="mb-4 flex flex-wrap items-center justify-between gap-2">
            <h4 className="flex items-center gap-2 text-sm font-bold text-foreground-900">
              <i className="ri-price-tag-3-line text-accent-600" aria-hidden="true" />
              吃瓜关键词云
            </h4>
            <span className="text-xs text-foreground-500">点标签可直达相关争议整理</span>
          </div>
          <div className="flex flex-wrap gap-2">
            {HOT_TAGS.map((t) => (
              <button
                key={t.name}
                type="button"
                className="group flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-full border border-background-300/70 bg-background-100 px-3 py-1.5 text-xs text-foreground-800 transition-colors hover:border-accent-300 hover:bg-accent-100"
              >
                <span className="font-medium text-foreground-900">#{t.name}</span>
                <span className="rounded-full bg-accent-100 px-1.5 py-px text-[10px] text-accent-800 group-hover:bg-accent-200">
                  {t.type}
                </span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}